import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import AdminPage from '../../shared/AdminPage'
import { useListAllKeyDatapoints } from '../../../../../api/groups'
import OperationalTable from '../../../../organisms/OperationalTable'
import Loading from '../../../../molecules/Loading'
import SydButton from '../../../../commonDesign/Button'

const levelMap = {
  1: 'Account',
  201: 'Client',
  3: 'Product'
}

const useStyles = makeStyles(theme => ({
  rightContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))

const defaultColumnConfig = {
  columns: [
    { Header: 'Id', accessor: 'datapointId' },
    { Header: 'Datapoint Name', accessor: 'displayName' },
    { Header: 'Automated', Cell: ({ row }) => row.original.automated ? 'Yes' : 'No' },
    { Header: 'Read-Only', Cell: ({ row }) => row.original.readOnly ? 'Yes' : 'No' },
    {
      Header: 'Level Type',
      Cell: ({ row }) => levelMap[row.original.levelTypeId]
    }
  ],
  defaultSort: [{ id: 'datapointId', desc: true }]
}

const KeyDataPoints = () => {
  const classes = useStyles()
  const { data: keyDataPoints = [], isLoading: loading } = useListAllKeyDatapoints()
  const history = useHistory()
  const onClickRow = useCallback(
    (row) => {
      if (row.original) {
        history.push(`/admin/data-maintenance/key-data-points/${row.original.codeName}`)
      }
    },
    [history]
  )
  if (loading) {
    return <Loading />
  }
  return (
    <AdminPage>
      <div className={classes.rightContainer}>
        <SydButton variant='primary' onClick={() => history.push('/admin/data-maintenance/key-data-points/new')}>
          Create Key Data Point
        </SydButton>
      </div>
      <OperationalTable
        variant='v2'
        columns={defaultColumnConfig.columns}
        mode='auto'
        defaultSort={defaultColumnConfig.defaultSort}
        data={keyDataPoints}
        loading={loading}
        onRowClick={row => { onClickRow(row) }}
      />
    </AdminPage>
  )
}

export default KeyDataPoints
